import { render } from "./Authenticator.vue?vue&type=template&id=78ae0c6e"
import script from "./Authenticator.vue?vue&type=script&lang=js"
export * from "./Authenticator.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__